$(document).ready(function () {
    let pagina_atual = 1;

    $('.carrega-mais').on('click', function (e) {
        e.preventDefault();
        let cat = $(this).data("category")
        pagina_atual++;
        fazerBusca(pagina_atual, cat);
    });
})

function fazerBusca(pagina_atual, cat) {
    $.ajax({
        type: 'POST',
        data: {
            action: 'carregarpost',
            pagina_atual: pagina_atual,
            cat: cat
        }, //nome da função desejada nos functions
        dataType: 'JSON',
        url: ajaxPrestus_vars.ajaxurl,
        beforeSend: function () {
            $('.loader').toggle();
            $('.carrega-mais').toggle();
        },
        success: function (retorno) {
            $('.loader').toggle();
            if (retorno.numero_pagina > pagina_atual) {
                $('.carrega-mais').toggle();
            }

            $.each(retorno.posts, function (index, value) {
                $('.campo-artigos').append(makePost(value));
            });
        }
    });
}

function makePost(post) {
    return ("<div class='postagem'>\
                <div class='detalhes' >\
                    <a href='" + post.link + "' class='link-thumb'>\
                        <img src='" + post.thumbnail + "' alt='" + post.title + "' class='thumb'>\
                    </a>\
                    <hr />\
                    <div class='autor'>\
                        <img src='" + post.avatar + "' alt='" + post.autor + "'>\
                        <h5>" + post.autor + "</h5>\
                    </div>\
                </div >\
                <div class='texto'>\
                    <a href='" + post.link + "' class='link-titulo'>\
                        <h5>" + post.title + "</h5>\
                    </a>\
                    <div class='campo'>\
                        <p>\
                            <a href='" + post.categoria_link + "' class='categoria'>" + post.categoria + "</a>\
                            – " + post.date + "\
                        </p>\
                        <p>" + post.excerpt + "</p>\
                    </div>\
                    <a href='" + post.link + "' class='link'>Leia mais</a>\
                </div>\
            </div > ");
}
